jQuery( document ).on( "page.ready", function () {
  $ = jQuery;

  if ( $( "main.blog" ).length ) {

    var category;
    // Filter Posts by Category on category button click
    $( ".cat-name" ).on( "click", function ( e ) {
      e.preventDefault();
      loadmore_params.current_page = 1;
      category = $( this ).attr( "data-category" );

      if ( $( ".no-mas" ).length ) {
        $( ".no-mas" ).remove();
      }

      $( ".cat-name" ).removeClass( "active" );
      $( this ).addClass( "active" );

      if ( category == "all" ) {
        category = "all";
      }

      data = {
        action: "filterposts",
        category: category
      };

      $.ajax( {
        url: loadmore_params.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function ( xhr ) {
          $( ".load-cats.loading-dots" ).show();
        },
        success: function ( data ) {
          $( ".loading-dots" ).hide();
          if ( data ) {
            $( ".blogpost-container" ).html( data.posts );
          } else {
            $( ".blogpost-container" ).html( "No posts found." );
          }
        }
      } );
    } );

    // Load more posts on Button Click
    $( ".loadmore" ).click( function ( e ) {
      e.preventDefault();
      var button = $( this ),
        data = {
          action: "loadmore",
          query: loadmore_params.posts, // that's how we get params from wp_localize_script() function
          page: loadmore_params.current_page,
          category: category
        };

      $.ajax( {
        // you can also use $.post here
        url: loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function ( xhr ) {
          $( ".load-more.loading-dots" ).show();
          button.hide();
        },
        success: function ( data ) {
          if ( data ) {
            $( ".blogpost-container" ).append( data );
            loadmore_params.current_page++;
            button.show();

            if ( loadmore_params.current_page == loadmore_params.max_page ) {
              button.hide(); // if last page, remove the button
            }
          } else {
            button.hide(); // if no data, remove the button as well
            $( ".load-more-container" ).append(
              '<p class="no-mas sub-title">That\'s all folks!</p>'
            );
          }

          $( ".load-more.loading-dots" ).hide();
        }
      } );
    } );

    $( ".cat-name" ).click( function () {
      $( ".loadmore" ).show();
    } );
  }
} );